<template>
  <v-app :class="$store.getters['user/isLogged']?'':'app-back'">
    <!--    <v-system-bar app></v-system-bar> !-->
    <AppHeader />
    <v-content app>
      <v-container fluid fill-height>
        <v-fade-transition mode="out-in" appear>
          <router-view />
        </v-fade-transition>
      </v-container>
    </v-content>
    <v-footer app>
      <span>{{footer_left}}</span>
      <v-spacer></v-spacer>
      <span>{{footer_right}}</span>
    </v-footer>
    <v-dialog width="400" v-model="showDialog" persistent>
      <v-card>
        <v-card-title class="warning lighten-5">
          <span>{{$t('session.title')}}</span>
          <v-spacer></v-spacer>
          <v-btn icon color="error" @click="prolong">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="my-4">{{$t('session.text')}}</div>
          <v-progress-linear height="25" :value="countdown" rounded color="teal"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar bottom v-model="snackbar" :color="snackbarColor">
      <v-icon dark>{{snackbarColor=='error'?'mdi-alert':'mdi-information-outline'}}</v-icon>
      <span v-html="snackbarMsg" />
      <v-btn icon @click="snackbar=false">
        <v-icon color="white">mdi-close-circle</v-icon>
      </v-btn>
    </v-snackbar>
    <!--    <v-bottom-navigation app>bottom</v-bottom-navigation> !-->
  </v-app>
</template>

<script>
import AppHeader from "@/components/AppHeader";
import app from "@/app.js";

export default {
  name: "App",

  components: {
    AppHeader
  },

  data: () => ({
    snackbar: false,
    snackbarColor: 'primary',
    snackbarMsg: "",
    footer_left: "",
    showDialog: false,
    countdown: 0,
    tm: 0
  }),
  computed: {
    footer_right() {
      return this.$t("copyright");
    },
  },
  methods: {
    prolong() {
      app.ping();
      this.clear();
    },
    clear() {
      clearInterval(this.tm);
      this.tm = null;
      this.showDialog = false;
    }
  },
  mounted() {
    this.$root.$on("set_footer_message", m => {
      this.footer_left = m;
    });
    this.$root.$on("show_snack", m => {
      this.snackbar = true;
      this.snackbarColor = m.color?'error':'primary';
      this.snackbarMsg = m.msg;
    });
    this.$root.$on("show_dialog", () => {
      //console.log("timeout id", this.tm);
      if (this.tm) return;
      this.countdown = 0;
      this.showDialog = true;
      this.tm = setInterval(() => {
        //console.log("cd", this.countdown, this.countdown > 99);
        this.countdown += 1;
        if (this.countdown > 99) {
          this.clear();
          app.gotoLogin();
        }
      }, 200);
    });
  }
};
</script>
<style scoped>
.app-back {
  background-image: url("assets/login_back.svg") !important;
  background-size: cover !important;
}

</style>
